export default __webpack_public_path__ + "svgs/bild-f56d6514.svg";